import React from "react";

import { Icon } from "@/components/atoms/Icon";

/**
 * Checks if the children of a component consist only of an icon.
 * @param children - The children of the component
 * @returns true if the children consist only of an icon, false otherwise
 */
const isIconOnly = (children: React.ReactNode): boolean => {
  const childrenArray = React.Children.toArray(children);
  const iconChild = childrenArray.find(
    (child) => React.isValidElement(child) && child.type === Icon,
  );
  const textChildren = childrenArray.filter(
    (child) =>
      !React.isValidElement(child) ||
      child.type !== Icon ||
      (typeof child === "string" && (child as string).trim() !== ""),
  );
  return !!iconChild && textChildren.length === 0;
};

export { isIconOnly };
